export enum MetaDataGroup {
  Variables = 'variables',
  Conditions = 'conditionTags',
  Skins = 'skins',
  TOCs = 'tocs'
}
